var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link",on:{"click":_vm.openItem}},[_vm._v(" "+_vm._s(_vm.linkItem[_vm.link.name])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }